import styled from "styled-components";
import {HomepageHeaderArenaTitleDefaultBox} from "./home-page-header-arena-title.default.box";

export const HomepageHeaderArenaTitleSIBox = styled(HomepageHeaderArenaTitleDefaultBox)`
    width: auto;
    color: ${({theme}) => theme.colors.brandPrimaryContrast};
    background-color: ${({theme}) => theme.colors.brandSecondaryContrast};
    border-bottom: 5px solid ${({theme}) => theme.colors.brandSecondaryLight};
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    ${({theme}) => theme.font.presets.secondary};
    font-size: 2.9rem;
    line-height: 1.2;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 2rem;
    }
`;
